import classNames from 'classnames';
import { UiContextMenuProps, UiContextMenuTheme } from '@nx-frontend/shared/types';
import { getContextMenuPosition } from './calculate-context-menu-position';
import { ContextMenuItem } from './context-menu-item';
import { themeClassesMap } from './context-menu-themes';
import './context-menu.css';

export const UiContextMenu: React.FC<UiContextMenuProps> = ({
  x,
  y,
  subX,
  subY,
  menuData,
  theme,
  themeClassesMenu,
  themeClassesItem,
  additionalStyles,
  closeContextMenu,
  zIndex,
  usePopperSubmenu,
}) => {
  let themeClasses = { menu: '', item: '' };

  if (themeClassesMenu && themeClassesItem) {
    themeClasses.menu = themeClassesMenu;
    themeClasses.item = themeClassesItem;
  } else {
    themeClasses = themeClassesMap[theme || UiContextMenuTheme.LIGHT];
  }

  const contextMenuClasses = `inline-block rounded-md border text-sm min-w-[186px] py-1 ${themeClasses.menu} ${additionalStyles}`;
  const style = zIndex
    ? { ...getContextMenuPosition(x, y, subX, subY), zIndex }
    : getContextMenuPosition(x, y, subX, subY);
  return (
    <ul className={classNames('absolute z-50', contextMenuClasses)} style={style} data-cy="blocks-context-menu">
      {menuData.map((item, index) => (
        <span key={index}>
          <ContextMenuItem
            item={item}
            closeContextMenu={closeContextMenu}
            subX={subX}
            subY={subY}
            theme={theme}
            classes={themeClasses}
            usePopperSubmenu={usePopperSubmenu}
          />
        </span>
      ))}
    </ul>
  );
};
